// @flow
import React from 'react';
import { connect, useSelector } from 'react-redux';

import { IconButton } from '../../base/buttons';
import { getParticipantCount } from '../../base/participants';
import { INVITE_GUEST_MODAL_ID } from '../../options';

export default function ParticipantsCount({
    
}) {
    const count = useSelector(state => getParticipantCount(state));
    const onClick = () => {
        if (APP.layout.header.invite) APP.UI.openModal(INVITE_GUEST_MODAL_ID);
    }

    return (
        <IconButton clsName="participant_cnt" hover={false}
            mode="headInvite" name={count} size={16} onClick={onClick} 
        />
    );
}